import { Customer, Order, Session } from "../models";
import { IAction } from "./IAction";
import { initialState } from "./reducer";

export enum ActionType {
    SET_CUSTOMER = "SET_CUSTOMER",
    SET_SESSION = "SET_SESSION",
    LOG_OUT_RESET_STATE = "LOG_OUT_RESET_STATE",
    ADD_ORDER = "ADD_ORDER",
    REMOVE_ORDER = "REMOVE_ORDER",
}

export const Actions = {
    SET_CUSTOMER: (customer: Customer): IAction => {
        return {
            type: ActionType.SET_CUSTOMER,
            payload: customer,
        };
    },
    SET_SESSION: (session: Session): IAction => {
        return {
            type: ActionType.SET_SESSION,
            payload: session,
        };
    },
    RESET_STATE: (): IAction => {
        return {
            type: ActionType.LOG_OUT_RESET_STATE,
            payload: initialState,
        };
    },
    ADD_ORDER: (order: Order): IAction => {
        return {
            type: ActionType.ADD_ORDER,
            payload: order,
        };
    },
    REMOVE_ORDER: (): IAction => {
        return {
            type: ActionType.REMOVE_ORDER,
            payload: undefined,
        };
    },
};
